import React, { useState } from 'react';
import { parseExcelFile, downloadSampleExcel } from '../utils/excelParser';
import { planRoute } from '../services/routeService';
import RouteMap from './RouteMap';

function OsrmView() {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [routeData, setRouteData] = useState(null);
  const [destination, setDestination] = useState({
    lat: 12.975095,
    lng: 77.757048,
  });

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      if (
        selectedFile.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
        selectedFile.type === 'application/vnd.ms-excel'
      ) {
        setFile(selectedFile);
        setError('');
      } else {
        setError('Please upload a valid Excel file (.xlsx or .xls)');
        setFile(null);
      }
    }
  };

  const handleUpload = async () => {
    if (!file) {
      setError('Please select a file first');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const employeeList = await parseExcelFile(file);

      if (!employeeList || employeeList.length === 0) {
        throw new Error('No valid employee data found in the Excel file');
      }

      console.log('Parsed employee list:', employeeList);

      const response = await planRoute(employeeList, destination);

      if (response.errorCode === 200) {
        setRouteData(response.responseData);
        console.log('Route data received:', response.responseData);
      } else {
        throw new Error(response.errorMessage || 'Failed to plan route');
      }
    } catch (err) {
      console.error('Error:', err);
      setError(err.message || 'An error occurred while processing the file');
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    setFile(null);
    setRouteData(null);
    setError('');
  };

  return (
    <>
      <div className="upload-section">
        <div className="card">
          <h2>Upload Employee Data</h2>

          <div className="destination-input">
            <h3>Destination Location</h3>
            <div className="input-group">
              <div className="input-field">
                <label>Latitude:</label>
                <input
                  type="number"
                  step="0.000001"
                  value={destination.lat}
                  onChange={(e) =>
                    setDestination({ ...destination, lat: parseFloat(e.target.value) })
                  }
                />
              </div>
              <div className="input-field">
                <label>Longitude:</label>
                <input
                  type="number"
                  step="0.000001"
                  value={destination.lng}
                  onChange={(e) =>
                    setDestination({ ...destination, lng: parseFloat(e.target.value) })
                  }
                />
              </div>
            </div>
          </div>

          <div className="file-upload">
            <input
              type="file"
              accept=".xlsx,.xls"
              onChange={handleFileChange}
              id="file-input-osrm"
              disabled={loading}
            />
            <label htmlFor="file-input-osrm" className="file-label">
              {file ? file.name : 'Choose Excel File'}
            </label>
          </div>

          {error && <div className="error-message">{error}</div>}

          <div className="button-group">
            <button
              onClick={handleUpload}
              disabled={loading || !file}
              className="btn btn-primary"
            >
              {loading ? 'Processing...' : 'Plan Routes'}
            </button>

            <button onClick={downloadSampleExcel} className="btn btn-secondary">
              Download Sample Excel
            </button>

            {routeData && (
              <button onClick={handleReset} className="btn btn-danger">
                Reset
              </button>
            )}
          </div>

          {file && (
            <div className="file-info">
              <strong>Selected File:</strong> {file.name}
            </div>
          )}
        </div>

        {loading && (
          <div className="loading-container">
            <div className="spinner"></div>
            <p>Planning optimal routes...</p>
          </div>
        )}
      </div>

      {routeData && (
        <div className="results-section">
          <div className="card">
            <h2>Route Results</h2>
            <div className="summary">
              <div className="summary-item">
                <span className="label">Total Trips:</span>
                <span className="value">{routeData.length}</span>
              </div>
              <div className="summary-item">
                <span className="label">Total Employees:</span>
                <span className="value">
                  {routeData.reduce((acc, trip) => acc + trip.employeeIds.length, 0)}
                </span>
              </div>
            </div>
          </div>

          <RouteMap routeData={routeData} destinationLocation={destination} />
        </div>
      )}
    </>
  );
}

export default OsrmView;
